import { createFileRoute, stripSearchParams } from '@tanstack/react-router'
import { z } from 'zod'

import Search from 'pages/Search'

export const searchSearchSchema = z.object({
  q: z.preprocess(
    (val) => (val != null ? String(val) : undefined),
    z.string().optional(),
  ),
})

const searchSearchDefaults = { q: undefined } as const

export const Route = createFileRoute('/_auth/_global/search')({
  component: Search,
  // Custom validateSearch: validate known keys via Zod, but preserve unknown
  // keys (prefixed table params like orgs_sort, projects_q, etc.).
  validateSearch: (search: Record<string, unknown>) => {
    const parsed = searchSearchSchema.parse(search)
    // Explicit q: ensures null from raw search can't leak through the spread
    // even if Zod omits the key when the value is undefined.
    return { ...search, ...parsed, q: parsed.q }
  },
  search: {
    middlewares: [stripSearchParams(searchSearchDefaults)],
  },
})
